import ItemNames from "../../mixins/item-name-list-search";
import ChecklistItemForm from "../../mixins/checklist-item-form";

Vue.component("checklist-item-create-form", {

  mixins: [ChecklistItemForm, ItemNames],

  props: ["area"],

  data() {
    return {
      form: new AppForm({})
    };
  },

  created() {
    this.createNewItemForm();
  },

  computed: {

    hasCleanlinessValue() {
      return !_.isEmpty(this.form.cleanliness);
    },

    hasDamageValue() {
      return !_.isEmpty(this.form.damage);
    },

    hasFunctioningValue() {
      return !_.isEmpty(this.form.functioning);
    }

  },

  methods: {

    createNewItemForm() {
      this.form = new AppForm({
        cleanliness: null,
        damage: null,
        functioning: null
      });
    },

    setCleanliness(cleanliness = null) {
      this.form.cleanliness = cleanliness;
    },

    setDamage(damage = null) {
      this.form.damage = damage;
    },

    setFunctioning(functioning = null) {
      this.form.functioning = functioning;
    },


    create() {

      App.post("/inspections/areas/" + this.area.id + "/items/create", this.form)
        .then(response => {
          this.createNewItemForm();
          toastr.success("Item created!");
          this.$emit("item-created", response);
        })
        .catch(() => {
          toastr.error("Error creating item!");
        });

    }

  }

});
